import React from 'react';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import clsx from 'clsx';
import { AuthContext } from '@shared/contexts';
import { OutsideClickTracker } from '@shared/components';
import { APP_LIST, PERMISSIONS } from '@shared/constants';
import { isAuthorized } from '@utils';
import config from '@config';

import Avatar from '@material-ui/core/Avatar';
import RCAvatar from '@assets/icons/rc-filled.svg';
import TimeTrackImg from '@assets/icons/time-track.png';
import ConductorImg from '@assets/icons/conductor.png';
import useStyles from './style';

export default ({
  className = '',
  currentApp = APP_LIST.CONDUCTOR,
  disabled = false,
}) => {
  const classes = useStyles();
  const { getToken } = React.useContext(AuthContext);
  const [isOpen, setIsOpen] = React.useState(false);
  const avatarRef = React.useRef(null);
  const [arrowRef, setArrowRef] = React.useState(null);
  return (
    <div className={className}>
      <OutsideClickTracker
        onClickAway={() => {
          setIsOpen(false);
        }}
        isListening={isOpen}
      >
        <>
          <span
            className={clsx({
              'no-events': disabled,
            })}
            // onClick={event => {
            //   setIsOpen(prevState => !prevState);
            // }}
          >
            <Avatar
              ref={avatarRef}
              src={RCAvatar}
              className={classes.avatar}
              classes={{ img: classes.avatarImg }}
            />
          </span>
          <div className={'popper-root'}>
            <Popper
              open={isOpen}
              anchorEl={avatarRef.current}
              disablePortal
              className='popper-w-arrow'
              placement='bottom-end'
              modifiers={{
                hide: {
                  enabled: false,
                },
                arrow: {
                  enabled: true,
                  element: arrowRef,
                },
                flip: {
                  enabled: false,
                },
                preventOverflow: {
                  enabled: false,
                  boundariesElement: 'scrollParent',
                },
              }}
            >
              <span
                ref={setArrowRef}
                className={clsx('popper-arrow', classes.arrow)}
              ></span>
              <Paper elevation={4}>
                <ul className={clsx('d-flex', 'p-0', classes.list)}>
                  <li
                    className={clsx(
                      'align-center',
                      'd-inline-flex',
                      'flex-column',
                      {
                        'c-pointer': currentApp !== APP_LIST.CONDUCTOR,
                      },
                      classes.listItem
                    )}
                    onClick={() => {
                      if (
                        currentApp === APP_LIST.CONDUCTOR ||
                        !config.conductorUrl
                      ) {
                        return;
                      }

                      const url = `${
                        config.conductorUrl
                      }/token?access_token=${getToken()}&returnurl=${
                        config.conductorUrl
                      }/workspaces`;
                      setIsOpen(false);
                      window.open(url, '_blank');
                    }}
                  >
                    <img src={ConductorImg} alt='conductor' />
                    Conductor
                  </li>
                  <li
                    className={clsx(
                      'align-center',
                      'd-inline-flex',
                      'flex-column',
                      {
                        'c-pointer': currentApp !== APP_LIST.TIME_TRACKER,
                      },
                      classes.listItem
                    )}
                    onClick={() => {
                      if (
                        currentApp === APP_LIST.TIME_TRACKER ||
                        !config.timeTrackUrl
                      ) {
                        return;
                      }

                      const url = `${
                        config.timeTrackUrl
                      }/token?access_token=${getToken()}&returnurl=${
                        config.timeTrackUrl
                      }/entries`;
                      setIsOpen(false);
                      window.open(url, '_blank');
                    }}
                  >
                    <img src={TimeTrackImg} alt='time track' />
                    Time Tracker
                  </li>
                </ul>
              </Paper>
            </Popper>
          </div>
        </>
      </OutsideClickTracker>
    </div>
  );
};
